// extracted by mini-css-extract-plugin
export var calender = "card-module--calender--b7f36";
export var card = "card-module--card--2a143";
export var card_capture = "card-module--card_capture--8e2f5";
export var card_category = "card-module--card_category--6b8f6";
export var card_container = "card-module--card_container--ad0b2";
export var date = "card-module--date--80c22";
export var date_icon = "card-module--date_icon--80306";
export var description = "card-module--description--f3ae7";
export var tags = "card-module--tags--17c03";
export var title = "card-module--title--2c4b0";
export var update = "card-module--update--f650d";